import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

interface $AccordionContainerProps {
  $naked: boolean;
  $isList?: boolean;
  $withoutMargin?: boolean;
}

export const $AccordionContainer = styled.div<$AccordionContainerProps>`
  margin-bottom: ${({ $isList, $withoutMargin }) =>
    $isList || $withoutMargin ? 'unset' : spacing(5)};
  background-color: ${({ theme, $naked }) => {
    return $naked ? null : theme.systemColors.defaultBackground;
  }};

  border-radius: ${({ $isList, theme }) =>
    $isList ? '0' : theme.tw.radius.md};
`;

export const $AccordionHeaderContentTitle = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
`;

export const $AccordionTitleText = styled.div`
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const $AccordionHeaderMinimal = styled.div`
  display: flex;
  gap: ${spacing('sm')};
  align-items: center;
  position: relative;

  flex-direction: row;
`;

export const $Separator = styled.div`
  content: '';
  height: ${spacing('px')};
  background-color: ${({ theme }) => theme.newUI.variationColors.light4};
  z-index: 5;

  flex: 1;
`;
